import { i18n } from '@zet/localization'

const hingeContent = {
  18: {
    text: i18n.t('magnetBenefits.rupayUpiCC'),
    show: true,
    svg: 'RupayCard',
  },
  25: {
    text: i18n.t('creditBuilderLoansBenefits.guaranteedIncome'),
    show: true,
    svg: 'creditBuilder',
  },
  9: {
    text: i18n.t('sellAndWin'),
    show: false,
    svg: 'SellAndWin',
  },
  10: {
    text: i18n.t('sellAndWin'),
    show: false,
    svg: 'SellAndWin',
  },
  23: {
    text: i18n.t('sellAndWin'),
    show: false,
    svg: 'SellAndWin',
  },
  24: {
    text: i18n.t('sellAndWin'),
    show: false,
    svg: 'SellAndWin',
  },
}

export default hingeContent
